<template>
  <div class="mobile_view">
    <div class="right-content">
      <quiz-overview></quiz-overview>
    </div>
    <div class="left-content">
      <div class="quiz-content">
        <h2>Are you concerned about any of the following health issues or would you like to discuss any of the below?</h2>
      </div>

      <ol>
        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Cervical Cancer Screening', 'cervicalcancer')"
              :class="[healthIssue.cervicalcancer.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/gynaelogical_screening.png`) " />
            </span>
            <span class="option">Cervical Cancer Screening</span>
          </button>
        </li>
        <li v-if="showBreastOption">
          <button
              class="option-normal history_button"
              @click="showModal('Breast Check', 'breastcheck')"
              :class="[healthIssue.breastcheck.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/breastcheck.png`) " />
            </span>
            <span class="option">Breast Check</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Contraception', 'contraception')"
              :class="[healthIssue.contraception.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/contyraception.png`) " />
            </span>
            <span class="option">Contraception</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Pre-natal planning', 'reproductive')"
              :class="[healthIssue.reproductive.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/prenatalplanning.png`) " />
            </span>
            <span class="option">Pre-natal planning</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Menopause', 'menopause')"
              :class="[healthIssue.menopause.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/menopausalscreening.png`) " />
            </span>
            <span class="option">Menopause</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Sexual Health', 'sexualHealth')"
              :class="[healthIssue.sexualHealth.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/sexualhealth.png`) " />
            </span>
            <span class="option">Sexual Health</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Sports Fitness', 'sportsFitness')"
              :class="[healthIssue.sportsFitness.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/sportsscreening.png`) " />
            </span>
            <span class="option">Sports Fitness</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Fatigue', 'fatigue')"
              :class="[healthIssue.fatigue.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/fatigue.png`) " />
            </span>
            <span class="option">Fatigue</span>
          </button>
        </li>

        <li>
          <button
              class="option-normal"
              @click="showModal('Skin', 'skin')"
              :class="[healthIssue.skin.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/skinscreening.png`) " />
            </span>
            <span class="option">Skin</span>
          </button>
        </li>

        <li>
          <button
              class="option-normal"
              @click="showModal('Smoking', 'smoking')"
              :class="[healthIssue.smoking.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/smoking.png`) " />
            </span>
            <span class="option">Smoking</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Travel Health', 'travelHealth')"
              :class="[healthIssue.travelHealth.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/travelhealth.png`) " />
            </span>
            <span class="option">Travel Health</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="selectNone"
              :class="[healthIssue.none.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/noneofthese.png`) " />
            </span>
            <span class="option">None</span>
          </button>
        </li>
      </ol>

      <div class="button-content">
        <button class="btn-prev w-btn us-btn-style_2" @click="prevQuiz">
          <span class="w-btn-label">&larr; Prev</span>
        </button>
        <button
            class="btn-next w-btn us-btn-style_1"
            :class="[buttonActive ? 'btn-active' : '']"
            :disabled="!buttonActive"
            @click="nextQuiz">
          <span class="w-btn-label">Next &rarr;</span>
        </button>
      </div>
      <modals-container @saveHistory="saveInfo" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import QuizHistoryModal from "./QuizHistoryModal.vue";
import QuizOverview from "./QuizOverview.vue";
import swal from "sweetalert";
import modalContents from "../data/modal-contents.json";

export default {
  name: "QuizHealthWoman",

  components: { QuizOverview },

  data() {
    return {
      healthIssue: {
        sexualHealth: {
          selected: false,
          desc: "Sexual Health",
          detail: ""
        },
        fatigue: {
          selected: false,
          desc: "Fatigue",
          detail: ""
        },
        skin: {
          selected: false,
          desc: "Skin",
          detail: ""
        },
        smoking: {
          selected: false,
          desc: "Smoking",
          detail: ""
        },
        coeliac: {
          selected: false,
          desc: "Coeliac",
          detail: ""
        },
        bowelDisease: {
          selected: false,
          desc: "Bowel Disease",
          detail: ""
        },
        menopause: {
          selected: false,
          desc: "Menopause",
          detail: ""
        },
        cervicalcancer: {
          selected: false,
          desc: "Cervical Cancer Screening",
          detail: ""
        },
        breastcheck: {
          selected: false,
          desc: "Breast Check",
          detail: ""
        },
        travelHealth: {
          selected: false,
          desc: "Travel Health",
          detail: ""
        },
        contraception: {
          selected: false,
          desc: "Contraception",
          detail: ""
        },
        sportsFitness: {
          selected: false,
          desc: "Sports Fitness",
          detail: ""
        },
        reproductive: {
          selected: false,
          desc: "Pre-natal planning",
          detail: ""
        },
        none: {
          selected: false,
          desc: "None – Other Health Issues"
        }
      }
    };
  },

  created: function() {
    let oldHealthIssue = this.getHealthIssue;
    let newHealthIssue = this.healthIssue;
    let healthIssueKeys = Object.keys( oldHealthIssue );

    if ( healthIssueKeys.length > 0 ) {
      healthIssueKeys.forEach( function( hKey ) {
        newHealthIssue[ hKey ] = oldHealthIssue[ hKey ];
      } );
    }

    this.healthIssue = newHealthIssue;
  },

  computed: {
    ...mapGetters( ["getHistory", "getDiscuss", "getHealthIssue", "getAge", "getGender"] ),

    buttonActive() {
      let flag = false;
      Object.keys( this.healthIssue ).forEach( key => {
        if ( this.healthIssue[ key ].selected === true ) {
          flag = true;
        }
      } );

      return flag;
    },
    showBreastOption() {
      if ( this.getGender !== 'female' ) {
        return false;
      }

      if ( this.getAge.includes( '50+' ) ) {
        return false;
      }

      return true;
    }
  },

  methods: {
    ...mapMutations( ["setStep", "setHealthIssue", "setCostInputed"] ),

    prevQuiz() {
      this.setStep( 3 );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    nextQuiz() {
      let flag = false;
      Object.keys( this.healthIssue ).forEach( key => {
        if ( this.healthIssue[ key ].selected === true ) {
          flag = true;
        }
      } );
      if ( ! flag ) {
        swal( "Warning!", "Please select at least one option.", "warning" );
        return;
      }
      this.setStep( 6 );
      this.setHealthIssue( this.healthIssue );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    selectNone() {
      Object.keys( this.healthIssue ).forEach( key => {
        if ( key !== "none" ) {
          this.healthIssue[ key ].selected = false;
        }
      } );

      this.healthIssue.none.selected = ! this.healthIssue.none.selected;

      this.setCostInputed( 5 );
      this.setHealthIssue( this.healthIssue );
    },

    showModal( text, type ) {
      if ( this.healthIssue[ type ].selected === false ) {
        this.$modal.show(
            QuizHistoryModal,
            {
              text,
              type,
              content: modalContents.healthIssue[ type ]
            },
            {
              height: "auto",
              adaptive: true
            }
        );
      } else {
        this.healthIssue[ type ].selected = false;
        this.healthIssue[ type ].detail = "";
      }
    },

    saveInfo( data ) {
      this.healthIssue.none.selected = false;

      var selected = 0;

      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      Object.keys( this.healthIssue ).forEach( key => {
        if ( this.healthIssue[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      if ( selected >= 2 ) {
        swal(
            "Info",
            "You may only choose a maximum of 2 Supplementary Screenings at one Health Screening. If you wish to add more please notify the clinic and we can try to accommodate your needs.",
            "info"
        );

        return;
      }

      this.healthIssue[ data.type ].selected = true;
      this.healthIssue[ data.type ].detail = data.info;

      this.setCostInputed( 5 );
      this.setHealthIssue( this.healthIssue );
    }
  }
};
</script>
